<div class="app_payment">
    <div id="payment_gosell"></div>
    <!-- <p id="msg"></p> -->
    <!-- <button id="openLightBox" (click)="openLightBox()">open goSell LightBox</button> -->
    <!-- <button id="openPage" (click)="openPaymentPage()">open goSell Page</button>     -->
    <!-- <button id="submit-elements" (click)="pay()">Submit</button> -->
</div>